module.exports = __webpack_public_path__ + "img/completion2.2cbfc2f3.svg";